module.exports = ".footer {\n  position: relative;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: red;\n  color: white;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.scss
// module id = ./src/app/footer/footer.component.scss
// module chunks = main